import PettyCashTab from "./PettyCashTab";
import { Coins } from "lucide-react";

export default function PettyCash() {
  return (
    <div className="space-y-6" data-testid="petty-cash-page">
      <div>
        <div className="eyebrow text-muted-foreground">Finance</div>
        <h1 className="font-display text-4xl font-bold mt-1 flex items-center gap-2">
          <Coins className="w-8 h-8 text-primary" /> Petty Cash
        </h1>
        <p className="text-muted-foreground mt-1">
          Daily petty-cash entries, mandatory bills, and monthly totals.
        </p>
      </div>
      <PettyCashTab />
    </div>
  );
}
